// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RecentDocumentsStyles } from "@conklin/App/Widgets/RecentDocuments/RecentDocuments";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

RecentDocumentsStyles.wrapper = {
    css: css`
        border: 1px solid ${color("common.border")};
        background-color: ${color("common.white")};
        border-radius: 4px;
        background-color: ${color("common.ui1")};
        overflow: hidden;
    `,
};

RecentDocumentsStyles.titleWrapper = {
    css: css`
        background-color: ${color("primary.main")};
        padding: 8px 12px;
    `,
};

RecentDocumentsStyles.title = {
    color: "common.white",
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

RecentDocumentsStyles.emptyTableMessage = {
    size: 14,
    css: css`
        line-height: 22px;
        padding: 12px;
        display: block;
    `,
};

RecentDocumentsStyles.dataTable = {
    css: css`
        margin: 12px;
        width: calc(100% - 24px);
        table-layout: fixed;
    `,
};

RecentDocumentsStyles.tableHead = {
    css: css`
        background-color: ${color("common.ui6")};
    `,
};

RecentDocumentsStyles.headerCell = {
    css: css`
        padding: 6px 12px;
        ${xScreen("lte", "lg")} {
            padding: 8px;
        }
    `,
    typographyProps: {
        color: "common.white",
        weight: fontConfig.weight.bold,
        size: 12,
        css: css`
            line-height: 15px;
        `,
    },
};

RecentDocumentsStyles.cellText = {
    typographyProps: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
        `,
    },
};

RecentDocumentsStyles.cell = {
    css: css`
        width: 50%;
        padding: 8px 12px;
        ${xScreen("lte", "lg")} {
            padding: 8px;
        }
    `,
};

RecentDocumentsStyles.text = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};
